// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-desktop-banner {
  --mdb-accent-rgb: 239, 68, 68;
  position: sticky;
  top: 0;
  z-index: 999;
  margin: 0.75rem 0.75rem 0;
  padding: 0.85rem 0.95rem;
  border: 1px solid var(--border-default, rgba(255, 255, 255, 0.1));
  border-radius: var(--radius-2xl, 16px);
  background: var(--bg-card, rgba(255, 255, 255, 0.03));
  box-shadow: var(--shadow-md, 0 4px 6px rgba(0, 0, 0, 0.4));
  backdrop-filter: var(--glass-blur, blur(10px));
  -webkit-backdrop-filter: var(--glass-blur, blur(10px));
  overflow: hidden;
}

.mobile-desktop-banner::before {
  content: '';
  position: absolute;
  inset: 0 auto auto 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--accent-primary-border, rgba(239, 68, 68, 0.3)), transparent);
  pointer-events: none;
}

.mobile-desktop-banner--naplex-prep,
.mobile-desktop-banner--ptcb-prep {
  top: 0;
  margin: 0 0 0.75rem;
}

.mobile-desktop-banner__inner {
  position: relative;
  display: grid;
  gap: 0.85rem;
}

.mobile-desktop-banner__copy {
  padding-right: 2.25rem;
}

.mobile-desktop-banner__eyebrow {
  margin: 0 0 0.3rem;
  color: var(--accent-primary, #ef4444);
  font-size: var(--text-xs, 0.65rem);
  font-weight: var(--font-weight-semibold, 600);
  letter-spacing: var(--tracking-widest, 0.1em);
  text-transform: uppercase;
}

.mobile-desktop-banner__headline {
  margin: 0;
  color: var(--text-primary, #ffffff);
  font-size: var(--text-base, 0.875rem);
  font-weight: var(--font-weight-bold, 700);
  line-height: var(--leading-tight, 1.2);
}

.mobile-desktop-banner__subtext {
  margin: 0.35rem 0 0;
  color: var(--text-muted, #9ca3af);
  font-size: var(--text-sm, 0.75rem);
  line-height: var(--leading-normal, 1.5);
}

.mobile-desktop-banner__close {
  position: absolute;
  top: 0;
  right: 0;
  width: 2rem;
  height: 2rem;
  border: 1px solid var(--border-subtle, rgba(255, 255, 255, 0.06));
  border-radius: var(--radius-full, 9999px);
  background: var(--bg-surface, rgba(255, 255, 255, 0.02));
  color: var(--text-subtle, #6b7280);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast, 150ms ease);
}

.mobile-desktop-banner__close:hover,
.mobile-desktop-banner__close:focus-visible {
  border-color: var(--accent-primary-border, rgba(239, 68, 68, 0.3));
  color: var(--text-primary, #ffffff);
  background: var(--accent-primary-muted, rgba(239, 68, 68, 0.15));
}

.mobile-desktop-banner__close:focus-visible,
.mobile-desktop-banner__input:focus-visible,
.mobile-desktop-banner__submit:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px var(--accent-primary, #ef4444), 0 0 0 4px var(--accent-primary-muted, rgba(239, 68, 68, 0.15));
}

.mobile-desktop-banner__form {
  display: grid;
  gap: 0.65rem;
}

.mobile-desktop-banner__controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.55rem;
}

.mobile-desktop-banner__input {
  min-width: 0;
  padding: 0.6rem 0.85rem;
  border-radius: var(--radius-lg, 8px);
  border: 1px solid var(--border-default, rgba(255, 255, 255, 0.1));
  background: var(--bg-input, rgba(255, 255, 255, 0.05));
  color: var(--text-primary, #ffffff);
  font-size: var(--text-base, 0.875rem);
  transition: all var(--transition-fast, 150ms ease);
}

.mobile-desktop-banner__input::placeholder {
  color: var(--text-disabled, #4b5563);
}

.mobile-desktop-banner__input:hover {
  border-color: var(--border-strong, rgba(255, 255, 255, 0.15));
}

.mobile-desktop-banner__input:focus {
  background: var(--bg-input-focus, rgba(255, 255, 255, 0.08));
  border-color: var(--border-focus, rgba(255, 255, 255, 0.25));
}

.mobile-desktop-banner__submit {
  padding: 0.6rem 1rem;
  border: none;
  border-radius: var(--radius-lg, 8px);
  background: var(--accent-primary, #ef4444);
  color: var(--text-primary, #ffffff);
  font-size: var(--text-sm, 0.75rem);
  font-weight: var(--font-weight-semibold, 600);
  letter-spacing: var(--tracking-wide, 0.05em);
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  transition: all var(--transition-fast, 150ms ease);
}

.mobile-desktop-banner__submit-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.48rem;
}

.mobile-desktop-banner__spinner {
  width: 0.82rem;
  height: 0.82rem;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  border-top-color: currentColor;
  border-radius: var(--radius-full, 9999px);
  animation: mobile-desktop-banner-spin 700ms linear infinite;
}

.mobile-desktop-banner__submit:hover:not(:disabled) {
  background: var(--accent-primary-hover, #dc2626);
}

.mobile-desktop-banner__submit:disabled,
.mobile-desktop-banner__input:disabled,
.mobile-desktop-banner__close:disabled {
  cursor: wait;
  opacity: 0.7;
}

.mobile-desktop-banner__helper {
  min-height: 1rem;
  margin: 0;
  font-size: 0.76rem;
  letter-spacing: 0.04em;
}

.mobile-desktop-banner__helper--error {
  color: #fda4af;
}

.mobile-desktop-banner__helper--idle {
  color: var(--text-subtle, #6b7280);
}

.mobile-desktop-banner__success {
  display: grid;
  gap: 0.35rem;
  padding-right: 2.25rem;
}

.mobile-desktop-banner__success-label {
  margin: 0;
  color: var(--color-success, #22c55e);
  font-size: var(--text-xs, 0.65rem);
  font-weight: var(--font-weight-semibold, 600);
  letter-spacing: var(--tracking-widest, 0.1em);
  text-transform: uppercase;
}

.mobile-desktop-banner__success-text {
  margin: 0;
  color: var(--text-primary, #ffffff);
  font-size: var(--text-base, 0.875rem);
  line-height: var(--leading-normal, 1.5);
}

.mobile-desktop-banner[data-state='error'] {
  border-color: var(--accent-primary-border, rgba(239, 68, 68, 0.3));
}

.mobile-desktop-banner[data-state='success'] {
  border-color: var(--color-success, rgba(34, 197, 94, 0.3));
}

@keyframes mobile-desktop-banner-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 420px) {
  .mobile-desktop-banner {
    margin: 0.5rem 0.5rem 0;
    padding: 0.75rem;
  }

  .mobile-desktop-banner__controls {
    grid-template-columns: 1fr;
  }

  .mobile-desktop-banner__submit {
    width: 100%;
    justify-content: center;
  }
}

@media (min-width: 769px) {
  .mobile-desktop-banner {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MobileDesktopBanner.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,iEAAiE;EACjE,sCAAsC;EACtC,qDAAqD;EACrD,0DAA0D;EAC1D,8CAA8C;EAC9C,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,kHAAkH;EAClH,oBAAoB;AACtB;;AAEA;;EAEE,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,6CAA6C;EAC7C,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,qCAAqC;EACrC,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iEAAiE;EACjE,yCAAyC;EACzC,wDAAwD;EACxD,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kDAAkD;AACpD;;AAEA;;EAEE,kEAAkE;EAClE,mCAAmC;EACnC,gEAAgE;AAClE;;AAEA;;;EAGE,aAAa;EACb,oHAAoH;AACtH;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,iEAAiE;EACjE,sDAAsD;EACtD,mCAAmC;EACnC,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,4DAA4D;EAC5D,4DAA4D;AAC9D;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,oCAAoC;EACpC,0CAA0C;EAC1C,mCAAmC;EACnC,kCAAkC;EAClC,6CAA6C;EAC7C,4CAA4C;EAC5C,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,8BAA8B;EAC9B,yCAAyC;EACzC,2DAA2D;AAC7D;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;;EAGE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,kCAAkC;EAClC,6CAA6C;EAC7C,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".mobile-desktop-banner {\n  --mdb-accent-rgb: 239, 68, 68;\n  position: sticky;\n  top: 0;\n  z-index: 999;\n  margin: 0.75rem 0.75rem 0;\n  padding: 0.85rem 0.95rem;\n  border: 1px solid var(--border-default, rgba(255, 255, 255, 0.1));\n  border-radius: var(--radius-2xl, 16px);\n  background: var(--bg-card, rgba(255, 255, 255, 0.03));\n  box-shadow: var(--shadow-md, 0 4px 6px rgba(0, 0, 0, 0.4));\n  backdrop-filter: var(--glass-blur, blur(10px));\n  -webkit-backdrop-filter: var(--glass-blur, blur(10px));\n  overflow: hidden;\n}\n\n.mobile-desktop-banner::before {\n  content: '';\n  position: absolute;\n  inset: 0 auto auto 0;\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--accent-primary-border, rgba(239, 68, 68, 0.3)), transparent);\n  pointer-events: none;\n}\n\n.mobile-desktop-banner--naplex-prep,\n.mobile-desktop-banner--ptcb-prep {\n  top: 0;\n  margin: 0 0 0.75rem;\n}\n\n.mobile-desktop-banner__inner {\n  position: relative;\n  display: grid;\n  gap: 0.85rem;\n}\n\n.mobile-desktop-banner__copy {\n  padding-right: 2.25rem;\n}\n\n.mobile-desktop-banner__eyebrow {\n  margin: 0 0 0.3rem;\n  color: var(--accent-primary, #ef4444);\n  font-size: var(--text-xs, 0.65rem);\n  font-weight: var(--font-weight-semibold, 600);\n  letter-spacing: var(--tracking-widest, 0.1em);\n  text-transform: uppercase;\n}\n\n.mobile-desktop-banner__headline {\n  margin: 0;\n  color: var(--text-primary, #ffffff);\n  font-size: var(--text-base, 0.875rem);\n  font-weight: var(--font-weight-bold, 700);\n  line-height: var(--leading-tight, 1.2);\n}\n\n.mobile-desktop-banner__subtext {\n  margin: 0.35rem 0 0;\n  color: var(--text-muted, #9ca3af);\n  font-size: var(--text-sm, 0.75rem);\n  line-height: var(--leading-normal, 1.5);\n}\n\n.mobile-desktop-banner__close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 2rem;\n  height: 2rem;\n  border: 1px solid var(--border-subtle, rgba(255, 255, 255, 0.06));\n  border-radius: var(--radius-full, 9999px);\n  background: var(--bg-surface, rgba(255, 255, 255, 0.02));\n  color: var(--text-subtle, #6b7280);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast, 150ms ease);\n}\n\n.mobile-desktop-banner__close:hover,\n.mobile-desktop-banner__close:focus-visible {\n  border-color: var(--accent-primary-border, rgba(239, 68, 68, 0.3));\n  color: var(--text-primary, #ffffff);\n  background: var(--accent-primary-muted, rgba(239, 68, 68, 0.15));\n}\n\n.mobile-desktop-banner__close:focus-visible,\n.mobile-desktop-banner__input:focus-visible,\n.mobile-desktop-banner__submit:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 1px var(--accent-primary, #ef4444), 0 0 0 4px var(--accent-primary-muted, rgba(239, 68, 68, 0.15));\n}\n\n.mobile-desktop-banner__form {\n  display: grid;\n  gap: 0.65rem;\n}\n\n.mobile-desktop-banner__controls {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 0.55rem;\n}\n\n.mobile-desktop-banner__input {\n  min-width: 0;\n  padding: 0.6rem 0.85rem;\n  border-radius: var(--radius-lg, 8px);\n  border: 1px solid var(--border-default, rgba(255, 255, 255, 0.1));\n  background: var(--bg-input, rgba(255, 255, 255, 0.05));\n  color: var(--text-primary, #ffffff);\n  font-size: var(--text-base, 0.875rem);\n  transition: all var(--transition-fast, 150ms ease);\n}\n\n.mobile-desktop-banner__input::placeholder {\n  color: var(--text-disabled, #4b5563);\n}\n\n.mobile-desktop-banner__input:hover {\n  border-color: var(--border-strong, rgba(255, 255, 255, 0.15));\n}\n\n.mobile-desktop-banner__input:focus {\n  background: var(--bg-input-focus, rgba(255, 255, 255, 0.08));\n  border-color: var(--border-focus, rgba(255, 255, 255, 0.25));\n}\n\n.mobile-desktop-banner__submit {\n  padding: 0.6rem 1rem;\n  border: none;\n  border-radius: var(--radius-lg, 8px);\n  background: var(--accent-primary, #ef4444);\n  color: var(--text-primary, #ffffff);\n  font-size: var(--text-sm, 0.75rem);\n  font-weight: var(--font-weight-semibold, 600);\n  letter-spacing: var(--tracking-wide, 0.05em);\n  text-transform: uppercase;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all var(--transition-fast, 150ms ease);\n}\n\n.mobile-desktop-banner__submit-content {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.48rem;\n}\n\n.mobile-desktop-banner__spinner {\n  width: 0.82rem;\n  height: 0.82rem;\n  border: 1.5px solid rgba(255, 255, 255, 0.3);\n  border-top-color: currentColor;\n  border-radius: var(--radius-full, 9999px);\n  animation: mobile-desktop-banner-spin 700ms linear infinite;\n}\n\n.mobile-desktop-banner__submit:hover:not(:disabled) {\n  background: var(--accent-primary-hover, #dc2626);\n}\n\n.mobile-desktop-banner__submit:disabled,\n.mobile-desktop-banner__input:disabled,\n.mobile-desktop-banner__close:disabled {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n.mobile-desktop-banner__helper {\n  min-height: 1rem;\n  margin: 0;\n  font-size: 0.76rem;\n  letter-spacing: 0.04em;\n}\n\n.mobile-desktop-banner__helper--error {\n  color: #fda4af;\n}\n\n.mobile-desktop-banner__helper--idle {\n  color: var(--text-subtle, #6b7280);\n}\n\n.mobile-desktop-banner__success {\n  display: grid;\n  gap: 0.35rem;\n  padding-right: 2.25rem;\n}\n\n.mobile-desktop-banner__success-label {\n  margin: 0;\n  color: var(--color-success, #22c55e);\n  font-size: var(--text-xs, 0.65rem);\n  font-weight: var(--font-weight-semibold, 600);\n  letter-spacing: var(--tracking-widest, 0.1em);\n  text-transform: uppercase;\n}\n\n.mobile-desktop-banner__success-text {\n  margin: 0;\n  color: var(--text-primary, #ffffff);\n  font-size: var(--text-base, 0.875rem);\n  line-height: var(--leading-normal, 1.5);\n}\n\n.mobile-desktop-banner[data-state='error'] {\n  border-color: var(--accent-primary-border, rgba(239, 68, 68, 0.3));\n}\n\n.mobile-desktop-banner[data-state='success'] {\n  border-color: var(--color-success, rgba(34, 197, 94, 0.3));\n}\n\n@keyframes mobile-desktop-banner-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 420px) {\n  .mobile-desktop-banner {\n    margin: 0.5rem 0.5rem 0;\n    padding: 0.75rem;\n  }\n\n  .mobile-desktop-banner__controls {\n    grid-template-columns: 1fr;\n  }\n\n  .mobile-desktop-banner__submit {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (min-width: 769px) {\n  .mobile-desktop-banner {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
